import styled, { css } from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { BORDER_TOP } from './constants';
const borderTopStyle = ({ borderSize }) => borderSize
    ? css `
        border-top-width: ${borderSize};
      `
    : css `
        border-top-width: 4px;

        ${ADAPTIVE.minWidth.tablet} {
          border-top-width: 14px;
        }

        ${ADAPTIVE.minWidth.desktop} {
          border-top-width: 24px;
        }
      `;
const borderBottomStyle = ({ borderSize }) => borderSize
    ? css `
        border-bottom-width: ${borderSize};
      `
    : css `
        border-bottom-width: 4px;

        ${ADAPTIVE.minWidth.tablet} {
          border-bottom-width: 14px;
        }

        ${ADAPTIVE.minWidth.desktop} {
          border-bottom-width: 24px;
        }
      `;
export const BrandOverlineStyled = styled.div `
  border-width: 0;
  border-style: solid;

  ${({ borderColor }) => `border-color: ${borderColor};`}

  ${({ position, borderSize = undefined }) => position === BORDER_TOP
    ? borderTopStyle({
        borderSize,
    })
    : borderBottomStyle({
        borderSize,
    })};

  ${({ isBorderColorTransition }) => isBorderColorTransition && 'transition: border-color 300ms;'}

  ${({ isBorderWidthReset }) => isBorderWidthReset && 'border-width: 0px;'}

  ${({ isDefaultVerticalPadding }) => isDefaultVerticalPadding &&
    css `
      padding: 24px 0;

      ${ADAPTIVE.minWidth.desktop} {
        padding: 48px 0;
      }
    `}
`;
